/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findAll12 } from '../fn/app-state-action/find-all-12';
import { FindAll12$Params } from '../fn/app-state-action/find-all-12';
import { StateAction } from '../models/state-action';

@Injectable({ providedIn: 'root' })
export class AppStateActionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll12()` */
  static readonly FindAll12Path = '/api/values/app-state-actions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll12()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll12$Response(params?: FindAll12$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StateAction>>> {
    return findAll12(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll12$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll12(params?: FindAll12$Params, context?: HttpContext): Observable<Array<StateAction>> {
    return this.findAll12$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StateAction>>): Array<StateAction> => r.body)
    );
  }

}
